module.exports = __webpack_public_path__ + "static/media/offering-card-three.a1568cec.svg";